import { useQuery } from '@tanstack/react-query';

import { brandPageBySlugQueryOptions } from '../queries';

export function useBrandPageBySlug(slug: string) {
  return useQuery(brandPageBySlugQueryOptions(slug));
}
